<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1XXwAp/tc-custom/9781402790959.jpg?1705766095200" alt="This image is the cover for the book Out of the Depths"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Out of the Depths
      </h1>
      <p class="bookDescription body article font2">
        <b>In his astonishing memoir, the Holocaust survivor and Chief Rabbi of Israel shares his story of faith and perseverance through WWII and beyond.</b><br/><br/>Israel Meir Lau, one of the youngest survivors of Buchenwald, was just eight years old when the camp was liberated in 1945. Descended from a 1,000-year unbroken chain of rabbis, he grew up to become Chief Rabbi of Israel—and like many of the great rabbis, Lau is a master storyteller. <i>Out of the Depths</i> is his harrowing and inspiring account of life in one of the Nazis deadliest concentration camps, and how he managed to survive against all possible odds.<br/><br/>Lau, who lost most of his family in the Holocaust, also chronicles his life after the war, including his emigration to Mandate Palestine during a period that coincides with the development of the State of Israel. The story continues up through today, with that once-lost boy of eight now a brilliant, charismatic, and world-revered figure who has visited with Popes John Paul and Benedict; the Dalai Lama, Nelson Mandela, and countless global leaders including Ronald Reagan, Bill and Hillary Clinton, and Tony Blair.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Israel Meir Lau, Shimon Peres, Elie Wiesel
      </h2>
      
      <p class="authorDescription body article">Rabbi Lau is one of the world's most revered and charismatic Jewish leaders. Lau was born in 1937 in Poland, the son of his town's last Chief Rabbi. He served as the Ashkenazi Chief Rabbi of Israel from 1993 to 2003. Currently, he is Chief Rabbi of Tel Aviv and Chairman of Yad Vashem--Israel's official memorial organization to the Jewish victims of the Holocaust. In 2005, Lau was awarded the Israel Prize (the country's highest honor) for his lifetime achievements and special contribution to society and the State of Israel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sterling
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e01526b